exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".BtnClose_btnClose__3zpb9{width:50px;height:50px;opacity:.5;display:-webkit-flex;display:flex;justify-items:center;-webkit-align-items:center;align-items:center;-webkit-align-content:center;align-content:center;-webkit-justify-content:center;justify-content:center}.BtnClose_btnClose__3zpb9 svg>path{fill:#333}.BtnClose_btnClose__3zpb9:hover{opacity:.7}.BtnClose_btnClose__3zpb9.BtnClose_white__WsAtH,.BtnClose_btnClose__3zpb9:active{opacity:1}.BtnClose_btnClose__3zpb9.BtnClose_white__WsAtH svg>path{fill:#fff}.BtnClose_btnClose__3zpb9.BtnClose_white__WsAtH:hover{opacity:.7}.BtnClose_btnClose__3zpb9.BtnClose_white__WsAtH:active{opacity:.5}", ""]);

// exports
exports.locals = {
	"btnClose": "BtnClose_btnClose__3zpb9",
	"white": "BtnClose_white__WsAtH"
};